module.exports = __webpack_public_path__ + "static/img/aboutBg1.8c6f090.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/aboutBg1.png
// module id = dIZH
// module chunks = 1